import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Plan.css";
import cardCircleBlue from "../../Assets/Icon/card-circle-blue.png";
import cardCircleSilver from "../../Assets/Icon/card-circle-silver.png";
import cardCircleGold from "../../Assets/Icon/card-circle-gold.png";
import cardCirclePlatinum from "../../Assets/Icon/card-circle-platinum.png";
import cardSilverLogo from "../../Assets/Icon/card-silver-logo.png";
import WalletPlanPayModal from "../../components/Plan/WalletPlanPayModal";
import { LocationContext } from "../../CustomHelper/Helper";

const getFormattedFeatures = (features) => {
    try {
      let parsedFeatures;
      if (typeof features === 'string') {
        parsedFeatures = JSON.parse(features || '[]');
      } else {
        parsedFeatures = features || [];
      }

      // If parsedFeatures is an object with numeric keys, convert to array
      if (!Array.isArray(parsedFeatures) && typeof parsedFeatures === 'object' && parsedFeatures !== null) {
        parsedFeatures = Object.values(parsedFeatures);
      }

      // Ensure parsedFeatures is an array
      if (!Array.isArray(parsedFeatures)) {
        console.warn('Parsed features is not an array:', parsedFeatures);
        return ['Points earn and burn'];
      }

      // If array is empty, return default
      if (parsedFeatures.length === 0) {
        return ['Points earn and burn'];
      }

      const formatted = parsedFeatures
        .filter(feature => feature?.type && Number.isFinite(Number(feature.count)) && Number(feature.count) > 0)
        .map(feature => {
          const count = Number(feature.count);
          if (feature.type === 'market_place') {
            return `${count}% Marketplace Discount`;
          }
          if (feature.type === 'royalty_points') {
            return `${count}x Royalty Points`;
          }
          if (feature.type === 'meetup') {
            return `${count} Offline Meeting${count > 1 ? 's' : ''}`;
          }
          const typeName = feature.type
            .replace(/_/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());
          return `${count} ${typeName}${count > 1 ? 's' : ''}`;
        })
        .filter(Boolean);

      // console.log('Formatted features:', formatted);
      return formatted.length > 0 ? formatted : ['Points earn and burn'];
    } catch (error) {
      console.error('Error parsing features:', error);
      return ['Points earn and burn'];
    }
  };

const Plan = () => {
  const [getPlanList, setPlanList] = useState([]);
  const [showModal, setModalShow] = useState(false);
  const [modalPara, setModalPara] = useState(false);
  const [getCurrentPlan,setCurrentPlan] = useState({});
  // if my plan id 2 then remove plan id 1 from list, if plan id 3 then remove plan id 1 and 2 from list
  const filteredPlans = getPlanList.filter(
    (item) => item.id >= (getCurrentPlan?.current_plan_id || 0)
  );


  useEffect(() => {
    async function fetchCurrentPlan() {
      axios.post('/api/loyalty-wallet',{
            "action": "current_plan",
        }).then((res) => {
            if(res.status === 200){
                const dataRes = res.data.results

                console.log("current plan", dataRes)
                setCurrentPlan(dataRes)
            }
        })
    }
    fetchCurrentPlan();
    async function fetchPlanList() {
      const plans = await axios.post("/api/loyalty-wallet", {
        action: "plan_list",
      });
      if (plans.status === 200) {
        const packages = (plans.data.results || []).map(item => ({
          ...item,
          formattedFeatures: getFormattedFeatures(item.features),
        }));
        setPlanList(packages);
      }
    }
    fetchPlanList();
  }, [setPlanList]);
  const getUpgradePrice = (currentPlanId, upgradePlan) => {
    // if planId id 1 then from_blue, if 2 then from_silver, if 3 then from_gold
    // console.log("getCurrentPlan========", currentPlanId)
    if(currentPlanId === 1){
      return JSON.parse(upgradePlan.upgrade_price || '{}').from_blue || 0;
    }else if(currentPlanId === 2){
      return JSON.parse(upgradePlan.upgrade_price || '{}').from_silver || 0;
    }else if(currentPlanId === 3){
      return JSON.parse(upgradePlan.upgrade_price || '{}').from_gold || 0;
    }
    return 0;
  }

    const { slectedCurrency, payStatus } = useContext(LocationContext);
  
    const handelCuntrybasePrice = (fee) => {
      return (Number(fee) * Number(slectedCurrency?.currency_value)).toFixed(0);
    };


  const planItem = (item) => {
    return (
      <div className="row row-container">
        <div className="plan-card-container">
          <div className="membership-title">
            Membership: {item.title}
          </div>
          <div className="card-container-parent">
            <div
              className="card-container blue-card-container"
              style={{
                background: item.color,
              }}
            >
              <div className="card-info-container">
                <h1>{item.title}</h1>
                <div className="name">
                  <span>Name:</span>
                  <span>XXXX</span>
                </div>
                <div className="membership-no">
                  <span>Membership No: </span>
                  <span>XXXX</span>
                </div>
                <div className="validity-until">
                  <span>Valid until:</span>
                  <span>{item.validity} days</span>
                </div>
              </div>
              <div className="logo">
                <img src={cardCircleBlue} alt="" />
                <img src={cardSilverLogo} alt="" />
              </div>
            </div>
          </div>
          <div className="card-points">
            <span>
              {item.points_start} -{" "}
              {item.points_end === 0 ? "Unlimited" : item.points_end}
            </span>
            <span>Points Range</span>
          </div>
          <div className="card-benefits">
            <h1>{item.title} membership benefits:</h1>
            <ul>
              {item.formattedFeatures.map((txt, idx) => (
                <li key={`${item.id}-${idx}`}>{txt.trim()}</li>
              ))}
            </ul>
          </div>

          <div className="term-conditions">
            <Link>Term and conditions Applied</Link>
          </div>

          <div className="upgrade-btn-container">
            {getCurrentPlan.current_plan_id === item.id ? (
              <span className="current-plan-span">Currently on this plan</span>
            ) : getCurrentPlan.current_plan_id > item.id ? (
              <span className="current-plan-span">Downgrade Not Possible</span>
            ) : (
              <a href="javascript:void(0)" onClick={() => upgradePlan(getCurrentPlan.current_plan_id, item)}>
                <span className="upgrade-price-span">
                  Upgrade Now: { handelCuntrybasePrice(getUpgradePrice(getCurrentPlan.current_plan_id, item))}{" "}
                  {slectedCurrency?.symbol}
                </span>
              </a>
            )}
            
          </div>
        </div>
      </div>
    );
  };

  const upgradePlan = (currentPlanId, upgradePlan) => {
    
    const upgrade_price = getUpgradePrice(getCurrentPlan.current_plan_id, upgradePlan) || 0;
    const params = [upgradePlan.id, +upgrade_price, +upgrade_price]
    setModalPara(params);
    console.log("params", params);
    setModalShow(true);
  };

  return (
    <>
      <div className="plan-container">
        {filteredPlans?.map((item) => planItem(item))}
      </div>
      <WalletPlanPayModal
        setLiked={0}
        show={showModal}
        onHide={() => setModalShow(false)}
        modalPara={modalPara}
      />
    </>
  );
};

export default Plan;
